import React, {useState, useRef, useCallback} from "react"
import {
    Row,
    Col
} from "reactstrap";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {getRolesSelector} from "../../../redux/selectors/AdminSelector";
import {withRouter, Link} from "react-router-dom";
import {connect} from "react-redux";
import moment from 'moment';

const InterviewFilter = (props) => {
    const {query, setQuery} = props
    const [addedDate, setAddedDate] = useState(null);
    const [complitionDate, setComplitionDate] = useState(null);
    const formRef = useRef(null);

    const nameChange = (value) => {
        // if (value.keyCode === 13)
        setQuery({
            ...query,
            name: value.target.value,
        });
    };

    const remove = useCallback((key) => {
        setQuery(({[key]: value, ...query}) => query);
    }, []);

    const handleAddedDate = (date) => {
        if (date) {
            setAddedDate(date);
            setQuery({
                ...query,
                added_date: moment(date).format("MMM DD, YYYY"),
            });
        } else {
            remove('added_date')
            setAddedDate(date);
        }
    };

    const handlesComplitionDate = (date) => {
        if (date) {
            setComplitionDate(date);
            setQuery({
                ...query,
                complete_date: moment(date).format("MMM DD, YYYY"),
            });
        } else {
            remove('complete_date')
            setComplitionDate(date);
        }
    };

    const clearFilters = () => {
        setAddedDate(null);
        setComplitionDate(null);
        setQuery({});
        formRef.current.reset();
    };

    return (

        <div className="card candidate-filters  border border-primary">
            <div className="card-header">
                <h5 className="card-title">Interview Filters</h5>
            </div>
            <form ref={formRef} className=" card-body pb-0 ">
                <Row>
                    <Col lg={10}>
                        <Row>
                            <Col lg={3}>
                                <div className="form-group">
                                    <input
                                        name="name"
                                        placeholder="Name"
                                        className="form-control"
                                        onChange={(e) => nameChange(e)}
                                        type="text"
                                    />
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="form-group">
                                    <select
                                        name="status"
                                        className="form-control"
                                        type="select"
                                        onChange={(e) => setQuery({...query, status: e.target.value})}
                                    >
                                        <option value="">Status</option>
                                        <option value="pending">Pending</option>
                                        <option value="invited">Invited</option>
                                        <option value="completed">Completed</option>
                                        <option value="Started">Started</option>
                                    </select>
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="form-group">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            autoOk
                                            clearable
                                            format="yyyy-MM-dd"
                                            className="form-control"
                                            placeholder="Added Date"
                                            value={addedDate}
                                            onChange={(e) => handleAddedDate(e)
                                            }
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="form-group">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            autoOk
                                            clearable
                                            format="yyyy-MM-dd"
                                            className="form-control"
                                            placeholder="Completion Date"
                                            value={complitionDate}
                                            onChange={(e) => handlesComplitionDate(e)
                                            }
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={2}>
                        <Row className="mb-3">
                            <Col lg={12}>
                                <div className="form-group">
                                    <button type="button" className="btn btn-secondary btn-block"
                                            onClick={() => clearFilters()}>
                                        Clear Filters
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </form>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        Roles: getRolesSelector(state),
    }
}

export default (connect(mapStateToProps, null)(InterviewFilter));
